import { render } from "./EvolucaoRemocao.vue?vue&type=template&id=5fb0f602&scoped=true"
import script from "./EvolucaoRemocao.vue?vue&type=script&lang=js"
export * from "./EvolucaoRemocao.vue?vue&type=script&lang=js"

import "./EvolucaoRemocao.vue?vue&type=style&index=0&id=5fb0f602&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb0f602"]])

export default __exports__